import { Component } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { UI_ACTION_CONSTANTS } from "../services/logger/constants";
import { LoggerService } from "../services/logger/logger.service";

@Component({
  selector: 'app-user-consent',
  templateUrl: 'user-consent.component.html',
  styleUrls: ['./user-consent.component.scss'],
})
export class UserConsentBottomSheet {
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<UserConsentBottomSheet>,
    private _logger: LoggerService,
  ) {}

  setUserConsent(consent: boolean) {
    this._logger.setUserConsent(consent);

    if (consent) {
      // log home page opened ui action
      this._logger.log(UI_ACTION_CONSTANTS.OER_CONVERSION_PROCESS_STARTED);
    }

    this._bottomSheetRef.dismiss();
  }

}
